import { useState } from "react";
import { api, formatErr, setAuthToken } from "@/lib/api";

export const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setAuthToken(data.token);
      onLogin(data);
    } catch (e2) { setErr(formatErr(e2)); } finally { setBusy(false); }
  };

  return (
    <div className="login-box" data-testid="admin-login">
      <div><p className="label">Panel administracyjny</p><h1 style={{ marginTop: 12 }}>Zaloguj się</h1></div>
      <div className="fe-field"><label htmlFor="em">E-mail</label><input id="em" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" /></div>
      <div className="fe-field"><label htmlFor="pw">Hasło</label><input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit(e)} data-testid="login-password-input" /></div>
      {err && <p className="err" data-testid="login-error">{err}</p>}
      <button className="btn solid" onClick={submit} disabled={busy} data-testid="login-submit-btn">{busy ? "Logowanie…" : "Zaloguj"}</button>
      <a href="/" style={{ color: "var(--muted)", fontSize: 14 }}>← Wróć na stronę</a>
    </div>
  );
};
